import { isDefined } from 'common/TypeUtilities';
import { isNil } from 'lodash';
import { CustomizationCategory } from 'src/gqlReactTypings.generated.d';

export const getSelectedPortion = ({
  selectedCustomizations,
  foodItem,
}: {
  selectedCustomizations?: { customizationType: { category: CustomizationCategory }; portion?: string | null }[] | null;
  foodItem: { portion?: string | null };
}): string | undefined => {
  const servingSizeCustomization = (selectedCustomizations ?? []).find(
    ({ customizationType: { category } }) => category === CustomizationCategory.ServingSize
  );
  const selectedPortion = !isNil(servingSizeCustomization) ? servingSizeCustomization.portion : foodItem.portion;
  return selectedPortion ?? undefined;
};

export const getSelectedServingSize = ({
  selectedCustomizations,
  foodItem,
}: {
  selectedCustomizations?: { customizationType: { category: CustomizationCategory; name: string } }[] | null;
  foodItem: { servingSize?: string | null };
}): string | undefined => {
  const servingSizeCustomization = (selectedCustomizations ?? [])
    .filter(isDefined)
    .find(({ customizationType: { category } }) => category === CustomizationCategory.ServingSize);
  return servingSizeCustomization?.customizationType.name ?? foodItem.servingSize ?? undefined;
};

export const getSelectedSpiceLevel = ({
  selectedCustomizations,
  foodItem,
}: {
  selectedCustomizations?:
    | { customizationType: { category: CustomizationCategory; name: string; dataType: string } }[]
    | null;
  foodItem: { spiceLevel: number };
}): number => {
  const spiceLevelCustomization = (selectedCustomizations ?? [])
    .filter(isDefined)
    .find(
      ({ customizationType: { category, dataType } }) =>
        category === CustomizationCategory.SpiceLevel && dataType === 'int'
    );
  return spiceLevelCustomization ? parseInt(spiceLevelCustomization.customizationType.name, 10) : foodItem.spiceLevel;
};
